import { breakpoints } from '../utils/breakpoints';
import { scroll } from './locomotive';
import handleLazyLoadingProducts from './handleLazyLoadingProducts';

const handleCatMenu = () => {
  const isMobileVp = window.innerWidth < breakpoints.tablet;

  const selectors = {
    btn: isMobileVp ? '.js-cat-menu-link-mobile' : '.js-cat-menu-link',
    errorMsg: '.js-error-msg',
    header: '.js-header',
    itemContainer: '.js-product-list',
    loader: '.js-product-loader',
    section: '#products-catalog-list',
    selectTitle: '.js-select-active-cat',
  };

  const state = {
    active: 'is-active',
    inView: 'is-inview',
  };

  const classes = {
    noEvents: 'ui-no-events',
    hide: 'ui-hide',
  };

  const container = document.querySelector(selectors.itemContainer);

  if (container === null) return;

  let loaderSetTimeoutID = null;

  const btns = [...document.querySelectorAll(selectors.btn)];
  const loader = document.querySelector(selectors.loader);
  const select = document.querySelector(selectors.selectTitle);
  const errorMsg = document.querySelector(selectors.errorMsg);

  if (btns.length === 0) return;

  const findActiveBtn = (arr) => arr.find((el) => el.classList.contains(state.active));

  // Set active btn
  let activeBtn = findActiveBtn(btns);

  const loadMorePosts = async ({ taxonomy, postType, slug }) => {
    // Set params to connect with backend
    let params = new URLSearchParams();

    params.append('action', 'load_more');
    params.append('post_type', postType);
    params.append('post_taxonomy', taxonomy);
    params.append('post_term', slug);

    try {
      const resp = await fetch('/wp-admin/admin-ajax.php', {
        method: 'POST',
        body: params,
      });

      // Get data as text and parse to JSON
      const dataJSON = await resp.text();
      const { data } = JSON.parse(dataJSON);

      // Update container with received content
      container.innerHTML = data;

      // Toggle container inView class to force single product animation
      toggleContainerInView(false);
      toggleContainerVisibility(true);

      toggleLoaderVisibility(false);
      handleLazyLoadingProducts();
      setTimeout(() => toggleContainerInView(true), 100);
    } catch (err) {
      clearTimeout(loaderSetTimeoutID);

      container.innerHTML = '';

      // Toggle loader visibility
      toggleLoaderVisibility(false);

      // Toggle error message visibility
      toggleErrorMsg(true);
    }

    // Toggle btns pointer events
    toggleBtnsPointerEvents();

    scroll.update();
  };

  const updateActiveBtn = (currentBtn) => {
    if (isMobileVp) {
      select.textContent = currentBtn.textContent;
      scroll.scrollTo(selectors.section, {
        offset: -(document.querySelector(selectors.header)?.clientHeight ?? 0),
      });
    }

    activeBtn?.classList.remove(state.active);
    currentBtn.classList.add(state.active);

    activeBtn = currentBtn;
  };

  const toggleContainerInView = (force = undefined) => {
    container.classList.toggle(state.inView, force);
  };

  const toggleContainerVisibility = (force = undefined) => {
    container.classList.toggle(state.active, force);
  };

  const toggleLoaderVisibility = (force = undefined) => {
    loader.classList.toggle(state.active, force);
  };

  const toggleErrorMsg = (force = undefined) => {
    errorMsg.classList.toggle(state.active, force);
  };

  const toggleBtnsPointerEvents = (force = undefined) => {
    btns.forEach((btn) => btn.classList.toggle(classes.noEvents, force));
  };

  const handleBtnClick = (e) => {
    e.preventDefault();
    const { currentTarget: target } = e;
    const { url, taxonomy, postType, slug } = target.dataset;

    // Change window url history without reloading the page
    window.history.replaceState(null, '', url);

    // Toggle btns pointer events
    toggleBtnsPointerEvents();

    // Toggle error message visibility
    toggleErrorMsg(false);

    // Change active btn
    updateActiveBtn(target);

    // Toggle container visibility
    toggleContainerVisibility(false);
    loaderSetTimeoutID = setTimeout(() => toggleLoaderVisibility(true), 170);

    loadMorePosts({ slug, taxonomy, postType });
  };

  btns.forEach((btn) => {
    btn.addEventListener('click', handleBtnClick);
  });
};

export default handleCatMenu;
